module.exports = __webpack_public_path__ + "static/img/services10.0841391.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/services10.png
// module id = ktjl
// module chunks = 0